var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpClothNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 1280,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.51,907.12l24.62,91.44a25.93,25.93,0,0,0,18.31,18.31l91.44,24.62c14.83,4,14.83,25,0,29l-91.44,24.62a25.93,25.93,0,0,0-18.31,18.31l-24.62,91.44c-4,14.83-25,14.83-29,0l-24.62-91.44a25.93,25.93,0,0,0-18.31-18.31l-91.44-24.62c-14.83-4-14.83-25,0-29l91.44-24.62a25.93,25.93,0,0,0,18.31-18.31l24.62-91.44C1045.48,892.29,1066.52,892.29,1070.51,907.12Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.85,592l35.4,131.45a37.27,37.27,0,0,0,26.32,26.32L956,785.15c21.31,5.73,21.31,36,0,41.7l-131.45,35.4a37.27,37.27,0,0,0-26.32,26.32L762.85,1020c-5.73,21.31-36,21.31-41.7,0l-35.4-131.45a37.27,37.27,0,0,0-26.32-26.32L528,826.85c-21.31-5.73-21.31-36,0-41.7l131.45-35.4a37.27,37.27,0,0,0,26.32-26.32L721.15,592C726.88,570.67,757.12,570.67,762.85,592Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608,1010H373.2V465.07a32,32,0,0,0-32-32h-32a32,32,0,0,0-32,32v55.58l-95.65-40.5L288.75,246.8,462.1,179.64c38.64,48.06,100.12,77.42,166.9,77.42s128.26-29.36,166.9-77.42L969.25,246.8l107.13,233.35-95.65,40.5V465.07a32,32,0,0,0-32-32h-32a32,32,0,0,0-32,32V608a32,32,0,0,0,32,32H952l222.47-97.14A32,32,0,0,0,1191.08,500L1051,194.91a64,64,0,0,0-35-33l-250-96.87a16,16,0,0,0-20.27,8.16L733,100.4c-17.13,36.85-58,60.66-104,60.66s-86.91-23.81-104-60.66L512.33,73.24a16,16,0,0,0-20.27-8.16L242,162a64,64,0,0,0-35,33L66.93,500a32,32,0,0,0,16.6,42.84l193.74,82V1042a64,64,0,0,0,64,64H608a32,32,0,0,0,32-32v-32A32,32,0,0,0,608,1010Z",
    style: {
      fill: "#282828"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpClothNormal);
export default __webpack_public_path__ + "static/media/hp_cloth_normal.19f07ad28f16362881f3c881a39c36a6.svg";
export { ForwardRef as ReactComponent };